import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Dòng điều khoản đặt cạnh chỗ người dùng LẤY LINK (trang "Rải link lụm tiền",
 * modal "Thưởng thêm hoàn tiền"): lấy link = xác nhận đã đọc Chính sách chống
 * hành vi gian lận TTLK.
 */
export const ANTI_FRAUD_POLICY_PATH =
    '/trang/chinh-sach-chong-hanh-vi-gian-lan-trong-hoat-dong-tiep-thi-lien-ket-ttlk';

function AffiliateFraudPolicyNote({ className = '' }) {
    return (
        <p className={`text-xs text-content-3 leading-relaxed ${className}`}>
            Bằng việc lấy link, bạn xác nhận đã đọc và đồng ý tuân thủ{' '}
            <Link
                to={ANTI_FRAUD_POLICY_PATH}
                className="underline font-semibold text-brand-red"
            >
                Chính sách chống hành vi gian lận TTLK
            </Link>{' '}
            của Longhousee.
        </p>
    );
}

export default AffiliateFraudPolicyNote;
